// Study Hall HTTP calls (DESIGN.md 12): `{hall}a/*` with the session as a Bearer header, plus the
// forum owner key as `x-forum-mod` when this browser has one saved (the forum's mod panel stores
// it). Auth is by header only, never a cookie. Errors carry the server's human `reason`.
import { getSession } from "../app/account.js";

const LS_MODKEY = "revault:forum:modkey";
function modKey() { try { return localStorage.getItem(LS_MODKEY) || ""; } catch (e) { void e; return ""; } }
export const hasModKey = () => !!modKey();

export function createApi(prefix) {
	const base = String(prefix || "") + "a/";
	async function authed(path, { method = "GET", body } = {}) {
		const headers = {};
		const sess = getSession();
		if (sess && sess.token) headers.Authorization = "Bearer " + sess.token;
		const k = modKey();
		if (k) headers["x-forum-mod"] = k;
		if (body !== undefined) headers["Content-Type"] = "application/json";
		const res = await fetch(base + path, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), cache: "no-store", credentials: "omit" });
		let j = null;
		try { j = await res.json(); } catch (e) { void e; }
		if (!res.ok) {
			const err = new Error(j && typeof j.reason === "string" && j.reason ? j.reason : res.status === 403 ? "You can't do that." : "Something went wrong. Try again.");
			err.status = res.status;
			throw err;
		}
		return j && typeof j === "object" ? j : {};
	}
	// Counts only (ws_blocked / ws_ok). Resolves to the HTTP status (0 when the request failed):
	// a 503 means Study Hall itself is off or shedding, not that the network blocks sockets.
	async function beacon(kind) {
		try {
			const res = await fetch(base + "beacon", { method: "POST", body: kind, headers: { "Content-Type": "text/plain" }, keepalive: true, cache: "no-store", credentials: "omit" });
			return res.status;
		} catch (e) { void e; return 0; }
	}
	// A file from {hall}a/<path> as a Blob (the data download). Errors read like authed().
	async function download(path) {
		const headers = {};
		const sess = getSession();
		if (sess && sess.token) headers.Authorization = "Bearer " + sess.token;
		const res = await fetch(base + path, { headers, cache: "no-store", credentials: "omit" });
		if (!res.ok) {
			let j = null;
			try { j = await res.json(); } catch (e) { void e; }
			const err = new Error(j && typeof j.reason === "string" && j.reason ? j.reason : "Something went wrong. Try again.");
			err.status = res.status;
			throw err;
		}
		return res.blob();
	}
	return { authed, beacon, download };
}
